export type UserShiftSelectionForUrl = {
  date: string;
  userId: string;
  shiftId: string;
};

export function urlEncodeMultiDaySelection(
  inviteUsers: UserShiftSelectionForUrl[],
  bookUsers: UserShiftSelectionForUrl[],
): string {
  const inviteUserEncoded = inviteUsers
    .map((u) => urlEncodeUserShiftSelection(u))
    .join(':');
  const bookUserEncoded = bookUsers
    .map((u) => urlEncodeUserShiftSelection(u))
    .join(':');
  return `${inviteUserEncoded}~${bookUserEncoded}`;
}

export function urlEncodeUserShiftSelection(
  userShiftSelection: UserShiftSelectionForUrl,
): string {
  return `${userShiftSelection.date}_${userShiftSelection.userId}_${userShiftSelection.shiftId}`;
}

export type DecodedMultiDaySelection = {
  days: {
    date: string;
    shifts: {
      id: string;
      bookUserIds: string[];
      inviteUserIds: string[];
    }[];
  }[];
};

export function urlDecodeMultiDaySelection(
  encodedSelection: string,
): DecodedMultiDaySelection {
  const [inviteUsersEncoded, bookUsersEncoded] = encodedSelection.split('~');

  const inviteUsers = inviteUsersEncoded ? inviteUsersEncoded.split(':') : [];
  const bookUsers = bookUsersEncoded ? bookUsersEncoded.split(':') : [];

  const allUsers = [...inviteUsers, ...bookUsers];

  const daysMap = new Map<
    string,
    {
      date: string;
      shifts: Map<
        string,
        { id: string; bookUserIds: string[]; inviteUserIds: string[] }
      >;
    }
  >();

  allUsers.forEach((encodedUser) => {
    const [date, userId, shiftId] = encodedUser.split('_');

    if (!daysMap.has(date)) {
      daysMap.set(date, { date, shifts: new Map() });
    }

    const day = daysMap.get(date)!;

    if (!day.shifts.has(shiftId)) {
      day.shifts.set(shiftId, {
        id: shiftId,
        bookUserIds: [],
        inviteUserIds: [],
      });
    }

    const shift = day.shifts.get(shiftId)!;

    if (bookUsers.includes(encodedUser)) {
      shift.bookUserIds.push(userId);
    } else {
      shift.inviteUserIds.push(userId);
    }
  });
  const decodedSelection: DecodedMultiDaySelection = {
    days: Array.from(daysMap.values())
      .sort((a, b) => a.date.localeCompare(b.date))
      .map((day) => ({
        date: day.date,
        shifts: Array.from(day.shifts.values()),
      })),
  };

  return decodedSelection;
}
